
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetobhimashankartempotraveller() {



    const cardData =
    {
        keyword: 'Pune to Bhimashankar Tempo Traveller',
        heading: 'Mauli Cabs: Pune to Bhimashankar Tempo Traveller',
        headingDescription: 'Mauli Cabs offers reliable Pune to Bhimashankar Tempo Traveller, providing a comfortable and spacious ride for family outings, group trips, or corporate events. Our well-maintained tempo travellers are perfect for long-distance journeys, offering ample seating, air conditioning, and a smooth ride. Whether you are planning a relaxing beach getaway or a fun-filled adventure, we ensure your journey to Alibaug is stress-free and enjoyable. With professional drivers, on-time pickups, and transparent pricing with no hidden charges, Mauli Cabs ensures a pleasant travel experience.',

        top: 'Top Places to Visit in Bhimashankar with Mauli Cabs',

"topPlaces": [
    {
        "title": "Bhimashankar Temple",
        "description": "The Bhimashankar Temple, dedicated to Lord Shiva, is one of the twelve Jyotirlingas in India. It's an important pilgrimage site and a serene place surrounded by lush greenery."
    },
    {
        "title": "Bhimashankar Wildlife Sanctuary",
        "description": "A haven for nature lovers and wildlife enthusiasts, this sanctuary is home to various species, including the Indian giant squirrel, and offers scenic trekking routes."
    },
    {
        "title": "Hanuman Lake",
        "description": "A peaceful spot near the Bhimashankar Temple, Hanuman Lake is surrounded by beautiful forested areas and is ideal for a relaxing picnic or a quiet moment."
    },
    {
        "title": "Sahyadri Mountain Range",
        "description": "Bhimashankar lies at the heart of the Sahyadri Range, offering scenic treks and panoramic views of the surrounding hills and valleys."
    },
    {
        "title": "Gupta Bhimashankar",
        "description": "A lesser-known part of the Bhimashankar Temple, Gupta Bhimashankar is believed to be the original site of the Shiva shrine, located deep inside a dense forest."
    },
    {
        "title": "Pune to Bhimashankar Trek",
        "description": "A popular trekking route that takes adventurers through dense forests, picturesque landscapes, and streams, leading to the temple at the top."
    },
    {
        "title": "Bhimashankar Waterfalls",
        "description": "During the monsoon season, Bhimashankar Waterfalls is a beautiful sight, with water cascading down the rocky terrain surrounded by lush greenery."
    },
    {
        "title": "Mata Bhimashankar Temple",
        "description": "Situated near the Bhimashankar Temple, this smaller temple dedicated to Goddess Bhimashankari adds to the spiritual ambiance of the region."
    },
    {
        "title": "Bhimashankar Wildlife Trek",
        "description": "A trek through the Bhimashankar Wildlife Sanctuary offers the opportunity to spot diverse wildlife, including rare species and various flora, while exploring the natural beauty of the area."
    },
    {
        "title": "Saptashrungi Temple",
        "description": "Located near Bhimashankar, Saptashrungi Temple is a scenic and spiritual spot offering a chance to explore another significant pilgrimage site in the region."
    }
],

"services": [
    {
      "name": "Pune to Bhimashankar Bus Service",
      "description": "Comfortable bus service from Pune to Bhimashankar for group tours, family trips, and Jyotirlinga Darshan. Choose from various bus sizes based on your group."
    },
    {
      "name": "Pune to Bhimashankar Tempo Traveller on Rent",
      "description": "Rent a Tempo Traveller for your trip from Pune to Bhimashankar, offering a comfortable ride for groups visiting the Bhimashankar Jyotirlinga."
    },
    {
      "name": "17 Seater Tempo Traveller on Rent in Pune",
      "description": "Rent a 17-seater Tempo Traveller in Pune for a comfortable group travel experience to Bhimashankar, perfect for family and corporate outings."
    },
    {
      "name": "Pune Jyotirlinga Darshan Tempo Traveller",
      "description": "Book a Tempo Traveller for a guided Jyotirlinga Darshan tour from Pune to Bhimashankar, including transportation and expert guides for a smooth experience."
    },
    {
      "name": "Pune to Bhimashankar Mini Bus on Rent",
      "description": "Rent a mini bus for your journey from Pune to Bhimashankar. Ideal for large groups, this service ensures comfort and convenience during the trip."
    },
    {
      "name": "Pune to Bhimashankar One Day Trip",
      "description": "Book a one-day trip package from Pune to Bhimashankar, including transport, guided tour, and the opportunity to visit the Bhimashankar Jyotirlinga."
    },
    {
      "name": "Pune to Bhimashankar Tour Package Price",
      "description": "Explore different tour packages for the Bhimashankar Jyotirlinga Darshan from Pune, with customized pricing for transport, sightseeing, and other services."
    },
    {
      "name": "Pune to Mahabaleshwar Mini Bus On Rent",
      "description": "Rent a mini bus for your group trip from Pune to Mahabaleshwar or Bhimashankar. Ideal for group travel with spacious and comfortable seating."
    },
    {
      "name": "Pune to Bhimashankar Tour",
      "description": "Experience a well-organized tour from Pune to Bhimashankar, with options for comfortable travel by bus or tempo traveller and guided visits to the Jyotirlinga."
    },
    {
      "name": "Pune to Bhimashankar 14, 17, 20, 25 Seater Tempo Traveller",
      "description": "Rent a 14, 17, 20, or 25-seater Tempo Traveller for your trip from Pune to Bhimashankar, suitable for different group sizes with high comfort levels."
    },
    {
      "name": "Pune to Bhimashankar Jyotirlinga Darshan",
      "description": "Book a guided Jyotirlinga Darshan tour from Pune to Bhimashankar, ensuring a smooth and spiritual journey for groups and individuals."
    },
    {
      "name": "Pune Airport to Bhimashankar Jyotirlinga Mini Bus",
      "description": "Book a mini bus from Pune Airport to Bhimashankar for a seamless journey, offering convenience for both individual and group travelers visiting the Jyotirlinga."
    },
    {
      "name": "Rent a Mini Bus Cab in Pune",
      "description": "Rent a mini bus for any group travel needs in Pune, including trips to Bhimashankar, Mahabaleshwar, and other destinations."
    },
    {
      "name": "Best Bus Rental Services",
      "description": "Find the best bus rental services in Pune for all types of group travel, including trips to Bhimashankar, Mahabaleshwar, and other pilgrimage spots."
    }
  ],
  "tableData": [
    ["Pune to Bhimashankar Bus Service", "Pune to Bhimashankar Tempo Traveller on Rent"],
    ["17 Seater Tempo Traveller on Rent in Pune", "Pune Jyotirlinga Darshan Tempo Traveller"],
    ["Pune to Bhimashankar Mini Bus on Rent", "Pune to Bhimashankar One Day Trip"],
    ["Pune to Bhimashankar Tour Package Price", "Pune to Mahabaleshwar Mini Bus On Rent"],
    ["Pune to Bhimashankar Tour", "Pune to Bhimashankar 14, 17, 20, 25 Seater Tempo Traveller"],
    ["Pune to Bhimashankar Jyotirlinga Darshan", "Pune Airport to Bhimashankar Jyotirlinga Mini Bus"],
    ["Rent a Mini Bus Cab in Pune", "Best Bus Rental Services"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Pune to Bhimashankar Tempo Traveller",
        "WhyChoosedescription": "Mauli Cabs offers spacious and comfortable Tempo Travellers for your journey from Pune to Bhimashankar. Whether you are going for a religious visit, family trip, or a group outing, our Tempo Travellers ensure a smooth and enjoyable ride."
    },
    {
        "WhyChooseheading": "Ideal for Group Travel to Bhimashankar",
        "WhyChoosedescription": "Our Tempo Travellers are perfect for group travel. With ample seating, air conditioning, and enough luggage space, you and your companions can travel together comfortably and enjoy the scenic route to Bhimashankar."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers affordable pricing for your Pune to Bhimashankar Tempo Traveller rental. Our pricing is transparent, with no hidden charges, ensuring that you get the best value for your group travel needs."
    },
    {
        "WhyChooseheading": "Experienced Drivers for a Safe and Comfortable Journey",
        "WhyChoosedescription": "Our drivers are highly experienced and familiar with the Pune to Bhimashankar route. They ensure a safe, smooth, and timely journey while prioritizing the comfort of all passengers on board."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for your Pune to Bhimashankar Tempo Traveller bookings. Whether you are planning an early morning or late-night departure, we are always ready to serve you."
    },
    {
        "WhyChooseheading": "Instant Booking and Real-Time Tracking",
        "WhyChoosedescription": "With Mauli Cabs, booking your Tempo Traveller from Pune to Bhimashankar is quick and easy. Use our app or website to book instantly and track your ride in real-time for added convenience."
    },
    {
        "WhyChooseheading": "Safe, Sanitized, and Secure Vehicles",
        "WhyChoosedescription": "Your safety and comfort are our priorities. Our Tempo Travellers are regularly sanitized, and our drivers adhere to hygiene and safety protocols, ensuring a secure and clean travel experience to Bhimashankar."
    },
    {
        "WhyChooseheading": "Flexible Payment Options",
        "WhyChoosedescription": "Mauli Cabs offers various payment methods, including UPI, credit/debit cards, mobile wallets, and cash. Choose the payment option that works best for you, making the booking process seamless and easy."
    }
]










    }

    const faqData = [
        {
            question: 'How can I book a Tempo Traveller for a trip from Pune to Bhimashankar?',
            answer: 'Booking a Tempo Traveller for your Pune to Bhimashankar trip is easy with Mauli Cabs. Simply visit our website or mobile app, select "Tempo Traveller" from the vehicle options, enter your travel details (pickup and destination), and confirm your booking. Our customer support team is available anytime for assistance.',
        },
        {
            question: 'What is the seating capacity of the Tempo Traveller for Pune to Bhimashankar?',
            answer: 'The Tempo Traveller is available in different seating capacities ranging from 12 to 17 seats. It’s a great choice for large groups or families traveling to Bhimashankar, ensuring ample space for passengers and luggage.',
        },
        {
            question: 'Is the fare for the Tempo Traveller fixed for the Pune to Bhimashankar trip?',
            answer: 'Yes, the fare for the Tempo Traveller from Pune to Bhimashankar is fixed. The price includes fuel, driver charges, tolls, taxes, and other necessary fees. The total fare will be displayed before you confirm your booking, with no hidden charges.',
        },
        {
            question: 'Can I rent a Tempo Traveller for a round trip from Pune to Bhimashankar?',
            answer: 'Yes, you can rent a Tempo Traveller for a round-trip from Pune to Bhimashankar. A round-trip option is more economical for return journeys, ensuring that you get a smooth ride both ways.',
        },
        {
            question: 'Is the Tempo Traveller service available 24/7 for Pune to Bhimashankar?',
            answer: 'Yes, Mauli Cabs offers Tempo Traveller services 24/7 for your Pune to Bhimashankar trip. Whether you need to travel early in the morning or late at night, you can book a Tempo Traveller according to your preferred schedule.',
        },
        {
            question: 'Can I carry extra luggage in the Tempo Traveller for the Pune to Bhimashankar trip?',
            answer: 'Yes, the Tempo Traveller offers ample space for luggage. It’s perfect for carrying extra or bulky items, making it an ideal vehicle for family or group trips to Bhimashankar, where additional luggage is often needed.',
        },
        {
            question: 'What are the benefits of renting a Tempo Traveller for a Pune to Bhimashankar trip?',
            answer: 'The Tempo Traveller is a great choice for groups traveling from Pune to Bhimashankar. It provides comfort, air conditioning, spacious seating, and sufficient storage for luggage. It ensures a smooth, safe, and enjoyable ride for everyone in the group.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Vikas Patil",
            position: "Business Executive",
            text: "We rented a Tempo Traveller for a family trip to Bhimashankar from Pune. The vehicle was spacious, comfortable, and had plenty of room for our luggage. The driver was courteous, and the trip was hassle-free. Highly recommend Mauli Cabs for group travel!",
            image: "/img/testimonial/testimonial-thumb-1-109.png",
        },
        {
            name: "Ms. Shalini Desai",
            position: "Tourist",
            text: "I booked a Tempo Traveller for a group of friends traveling to Bhimashankar from Pune. The vehicle was perfect for our group of 14, and the ride was very comfortable. The booking process was smooth, and I’ll definitely consider Mauli Cabs for future trips!",
            image: "/img/testimonial/testimonial-thumb-1-110.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Bhimashankar Tempo Traveller",
        "description": "Rent tempo travellers from Pune to Bhimashankar for Jyotirlinga Darshan, one-day trips, and group tours. Available in 14, 17, 20, and 25-seater options.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "150"
        },
        "offers": {
          "@type": "Offer",
          "url": "https://www.maulicabs.com/pune-to-bhimashankar-tempo-traveller",
          "priceCurrency": "INR",
          "price": "40",
          "priceValidUntil": "2025-12-31"
        }
      };
      
      


    return (
        <div>
            <GTag/>

<Helmet>
        <title>Pune to Bhimashankar Tempo Traveller | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book tempo travellers for a comfortable trip from Pune to Bhimashankar for Jyotirlinga Darshan. Rent 14, 17, 20, and 25-seater mini buses for group tours and one-day trips."
        />
        <meta
          name="keywords"
          content="Pune to Bhimashankar Tempo Traveller, tempo traveller rent Bhimashankar, Bhimashankar Jyotirlinga darshan, pune to bhimashankar tour, bhimashankar one day trip, Bhimashankar 17 seater tempo"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>
      


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/138.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetobhimashankartempotraveller;